import {
    fetch_repData_Success,
    change_repData,
    preview_MedicalConclusion_Request,
    fetch_RRHR_QTcAlg_Success,
    verificate_CmpxIntervals
} from "../../actions/actionConstants";

const updateReportData = (state, action) => {
    if (state === undefined) {
        return null;
    }

    switch (action.type) {
        case fetch_repData_Success:
            return action.payload;

        case change_repData:
            return action.payload;

        case verificate_CmpxIntervals:
            return {
                ...state.reportData.report,
                representativeCmpx: {
                    ...state.reportData.report.representativeCmpx,
                    verificated: action.payload
                }
            };

        case preview_MedicalConclusion_Request:
            return {
                ...state.reportData.report,
                medicalConclusion: {
                    ...state.reportData.report.medicalConclusion,
                    state: "preview",
                    val: action.payload
                }
            };
        case fetch_RRHR_QTcAlg_Success: {
            const { HR, RRmin_ms, RRmax_ms, RRavg_ms, QTc, QTcAlgVals } = action.payload;
            const ans = {
                ...state.reportData.report,
                HR_RR: {
                    HR: { val: HR },
                    RRavg: { val: RRavg_ms },
                    RRmax: { val: RRmax_ms },
                    RRmin: { val: RRmin_ms }
                }
            };

            if (QTc !== undefined) {
                ans.representativeCmpx.QTc = { val: QTc };
            }
            if (QTcAlgVals !== undefined) {
                ans.representativeCmpx.QTcAlgVals = { val: QTcAlgVals };
            }

            return ans;
        }

        default:
            return state.reportData.report;
    }
};
export default updateReportData;
